/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the DmarcSummaryResponse interface.
 */
export function instanceOfDmarcSummaryResponse(value) {
    if (!('dkimPass' in value) || value['dkimPass'] === undefined)
        return false;
    if (!('dkimPassRate' in value) || value['dkimPassRate'] === undefined)
        return false;
    if (!('dmarcPass' in value) || value['dmarcPass'] === undefined)
        return false;
    if (!('dmarcPassRate' in value) || value['dmarcPassRate'] === undefined)
        return false;
    if (!('reportCount' in value) || value['reportCount'] === undefined)
        return false;
    if (!('spfPass' in value) || value['spfPass'] === undefined)
        return false;
    if (!('spfPassRate' in value) || value['spfPassRate'] === undefined)
        return false;
    if (!('totalMessages' in value) || value['totalMessages'] === undefined)
        return false;
    return true;
}
export function DmarcSummaryResponseFromJSON(json) {
    return DmarcSummaryResponseFromJSONTyped(json, false);
}
export function DmarcSummaryResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'dkimPass': json['dkim_pass'],
        'dkimPassRate': json['dkim_pass_rate'],
        'dmarcPass': json['dmarc_pass'],
        'dmarcPassRate': json['dmarc_pass_rate'],
        'reportCount': json['report_count'],
        'spfPass': json['spf_pass'],
        'spfPassRate': json['spf_pass_rate'],
        'totalMessages': json['total_messages'],
    };
}
export function DmarcSummaryResponseToJSON(json) {
    return DmarcSummaryResponseToJSONTyped(json, false);
}
export function DmarcSummaryResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'dkim_pass': value['dkimPass'],
        'dkim_pass_rate': value['dkimPassRate'],
        'dmarc_pass': value['dmarcPass'],
        'dmarc_pass_rate': value['dmarcPassRate'],
        'report_count': value['reportCount'],
        'spf_pass': value['spfPass'],
        'spf_pass_rate': value['spfPassRate'],
        'total_messages': value['totalMessages'],
    };
}
